import React from 'react';
import { Link } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';
import { Button, Card } from '@ygtechnologies/rubus-ui';

import { DateDisplay } from '@/components/localization';
import { BuyerProjectDeadline } from '@/types';
import { useIsImpersonating } from '@/utils/hooks';
import theme from './DeadlineBlock.module.scss';

interface Props {
    deadline: BuyerProjectDeadline;
    pendingCount: number;
    submitUrl: string;
}

export const SubmitPrompt: React.FC<Props> = ({ deadline, pendingCount, submitUrl }) => {
    // Match the new configurator: only impersonation blocks signing, not seller mode.
    const viewOnly = useIsImpersonating();

    if (pendingCount === 0) return null;

    return (
        <Card variant="flat" className={theme.submitPrompt}>
            <div className={theme.submitPromptText}>
                <Trans>
                    Done with the {pendingCount} choices that are due to {deadline.name} -{' '}
                    <DateDisplay value={deadline.deadline} />?
                </Trans>
            </div>
            <Button as={Link} to={submitUrl} variant="primary" disabled={viewOnly}>
                <Trans>Go to sign and send</Trans>
            </Button>
        </Card>
    );
};
